// import URDFLoader from 'urdf-loader';
import { lerp } from "../helpers";
import * as T from 'three';
import { MaxEquation } from "three";

let relativePositions = ["rPosX", "rPosY", "rPosZ", "rRotX", "rRotY", "rRotZ", "rRotW"]

export function animateRobot(time, robot, animationTable) {

    let robotPosition = [null, null, null, null, null, null, null]
    let setPosition = (robot, typeIndex, amount) => {
        robotPosition[typeIndex] = amount
    }

    let setValue = (control, value) => {
        let index = -1;
        for(let i = 0; i < relativePositions.length; i++) {
            if(relativePositions[i].trim() === control.trim()) {
                index = i
            }
        }
        if(index >= 0) {
            setPosition(robot, index, value)
        }
        else {
            robot.setJointValue(control, value)
        }
    }

    if (animationTable.length == 0) {
        return;
    }
    let endTime = animationTable[animationTable.length-1][0];
    let jointArr = animationTable.shift();
    // time is at beginning
    if (time == 0) {
        for (let i = 1; i < jointArr.length; i++) {
            setValue(jointArr[i], parseFloat(animationTable[0][i]))
        }
    }
    // time is past the end
    else if (time >= endTime) {
        for (let i = 1; i < jointArr.length; i++) {
            setValue(jointArr[i], parseFloat(animationTable[animationTable.length - 1][i]));
        }
    }
    // time is somewhere in the middle, need interpolation
    else {
        let upperIndex = animationTable.findIndex(row => row[0] >= time)
        if (upperIndex <= 0) {
            animationTable.unshift(jointArr);
            return;
        }
        else if (animationTable[upperIndex][0] == time) {
            for (let i = 1; i < jointArr.length; i++) {
                setValue(jointArr[i], animationTable[upperIndex][i]);
            }
        }
        let lowerIndex = upperIndex - 1;
        let interval = animationTable[upperIndex][0] - animationTable[lowerIndex][0];
        let t = (time - animationTable[lowerIndex][0]) / interval;

        for (let i = 1; i < jointArr.length; i++) {
            let jointValue = lerp(parseFloat(animationTable[lowerIndex][i]), parseFloat(animationTable[upperIndex][i]), t);
            setValue(jointArr[i], jointValue);
        }
    }
    let parent = robot.parent

    /*
        Spacial control is based off of gazebo coordinates, so trasnformations don't have to be performed on the motion data
        Gazebo uses quaternions so this converts from quaternion to euler angles
        XYZ -> YXY
        Possible TODO: Add python script to transform data, revert conversions here
    */
    if (robotPosition[0] != null) {
        parent.position.z = robotPosition[0]
    }
    if (robotPosition[1] != null) {
        parent.position.x = robotPosition[1]
    }
    if (robotPosition[2] != null) {
        parent.position.y = robotPosition[2]
    }
    if(robotPosition[3] != null && robotPosition[4] != null && robotPosition[5] != null && robotPosition[6] != null) {
        let q = new T.Quaternion(robotPosition[3], robotPosition[4], robotPosition[5], robotPosition[6])
        let axis = new T.Vector3()
        let angle = 0

        let t = q.w * q.w
        angle = 2 * Math.acos(q.w)
        axis.x = q.x / Math.max(Math.sqrt(1 - t), 0.00000001)
        axis.y = q.y / Math.max(Math.sqrt(1 - t), 0.00000001)
        axis.z = q.z / Math.max(Math.sqrt(1 - t), 0.00000001)

        let axis2 = new T.Vector3();
        axis2.z = axis.x
        axis2.x = axis.y
        axis2.y = axis.z
        
        let q2 = new T.Quaternion();
        q2.setFromAxisAngle(axis2, angle)
        parent.rotation.setFromQuaternion(q2)
    }

    animationTable.unshift(jointArr);
}

export function getTableIndex(time, animationTable) {
    const PRECISION = 3;
    let jointArr = animationTable.shift();
    let index;
    if (animationTable.length == 0 || time == 0) {
        index = 0;
    }
    let endTime = animationTable[animationTable.length-1][0];
    if(time >= endTime) {
        index = animationTable.length-1;
    } else {
        let upperIndex = animationTable.findIndex(row => row[0] >= time)
        if (upperIndex <= 0) {
            index = 0;
        }
        else if(animationTable[upperIndex][0] == time) {
            index = upperIndex;
        }
        else {
            let lowerIndex = upperIndex - 1;
            let interval = animationTable[upperIndex][0] - animationTable[lowerIndex][0];
            let t = (time - animationTable[lowerIndex][0]) / interval;
            let indexStr = lerp(lowerIndex, upperIndex, t).toString();
            if(indexStr.indexOf(".") > 1) {
                index = Number(Number(indexStr).toPrecision(indexStr.indexOf(".") + PRECISION));
            }
            else {
                index = Number(Number(indexStr).toPrecision(PRECISION + 1));
            }
        }
    }
    animationTable.unshift(jointArr);
    return index;
}

// no end to end interpolation
export function updateCamera(time, totalTime, bookmarkList, controls) {
    if(bookmarkList.length == 0) {
        return;
    }
    // start at the last index
    let index = bookmarkList.length-1;
    for(let i = 0; i < bookmarkList.length; i++) {
        if(bookmarkList[i].time <= time) {
            index = i;
        }
    }
    let mark1 = bookmarkList[index];
    let mark2 = bookmarkList[(index + 1) % bookmarkList.length];

    let t = 0;
    if(mark2.time > mark1.time) {
        t = (time - mark1.time) / (mark2.time - mark1.time)
    } else {
        if(time < mark1.time) {
            t = (time - mark1.time + totalTime) / (mark2.time + totalTime - mark1.time)
        } else {
            t = (time - mark1.time) / (mark2.time + totalTime - mark1.time)
        }
    }
     
    let cameraPos1 = mark1.cameraPos.clone();
    let targetVector1 = mark1.cameraLookAt.clone();
    let zoom1 = mark1.cameraZoom;

    let cameraPos2 = mark2.cameraPos;
    let targetVector2 = mark2.cameraLookAt
    let zoom2 = mark2.cameraZoom;

    controls.object.position.copy(cameraPos1.lerp(cameraPos2, t));
    controls.target.copy(targetVector1.lerp(targetVector2, t));
    controls.object.zoom = lerp(zoom1, zoom2, t);
    controls.object.updateProjectionMatrix();
    controls.dispatchEvent({ type: 'change' });
    controls.update();
}